export function convert24To12(time, language = 'en') {
  if (!time) return ''

  let [hours, minutes] = time.split(':').map(Number)
  if (hours === 24) hours = 0

  const isPM = hours >= 12
  const ampm = language === 'ar' ? (isPM ? 'م' : 'ص') : isPM ? 'PM' : 'AM'

  hours = hours % 12 || 12

  return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`
}

export function to24Hour(time12, language = 'en') {
  if (!time12) return ''

  let [time, modifier] = time12.trim().split(' ')
  let [hours, minutes] = time.split(':').map(Number)

  if (language === 'ar') {
    if (modifier === 'م') modifier = 'PM'
    if (modifier === 'ص') modifier = 'AM'
  }

  if (modifier === 'PM' && hours !== 12) {
    hours += 12
  }
  if (modifier === 'AM' && hours === 12) {
    hours = 0
  }

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}`
}
